import { ingestAPIObject } from "../utils/api";
export class PermissionTypeDTO {
    constructor(jsonData) {
        ingestAPIObject(this, jsonData);
    }
}
export var PermissionKey;
(function (PermissionKey) {
    // Admin
    PermissionKey["AssignPermissions"] = "assign_permissions";
    PermissionKey["ManageUserAccounts"] = "manage_user_accounts";
    PermissionKey["ManageInternalUserAccounts"] = "manage_internal_user_accounts";
    PermissionKey["ViewUserActivity"] = "view_user_activity";
    PermissionKey["ManageUserRoles"] = "manage_user_roles";
    // Notes
    PermissionKey["CreateFieldNotes"] = "create_field_notes";
    // Ticket
    PermissionKey["ViewPlantingTicketHistory"] = "view_planting_ticket_history";
    PermissionKey["EditPastPlantingTickets"] = "edit_past_planting_tickets";
    // Scheduling
    PermissionKey["ViewWeedingTasks"] = "view_weeding_schedules";
    PermissionKey["EditWeedingTasks"] = "set_weeding_schedules";
    PermissionKey["ViewThinningTasks"] = "view_thinning_schedules";
    PermissionKey["EditThinningTasks"] = "set_thinning_schedules";
    PermissionKey["ViewFleecingTasks"] = "view_fleecing_schedules";
    PermissionKey["EditFleecingTasks"] = "set_fleecing_schedules";
    PermissionKey["ViewSoilSampleTasks"] = "view_soil_sample_schedules";
    PermissionKey["EditSoilSampleTasks"] = "edit_soil_sample_schedules";
    PermissionKey["ViewGeneralTasks"] = "view_general_tasks";
    PermissionKey["EditGeneralTasks"] = "edit_general_tasks";
    PermissionKey["ViewChemicalTasks"] = "view_chemical_schedules";
    PermissionKey["EditChemicalTasks"] = "edit_chemical_schedules";
    PermissionKey["ViewPlantingTasks"] = "view_planting_schedules";
    PermissionKey["EditPlantingTasks"] = "set_planting_schedules";
    PermissionKey["EditIrrigationTasks"] = "set_irrigation_schedules";
    PermissionKey["ViewIrrigationTasks"] = "view_irrigation_schedules";
    PermissionKey["CreateTaskRequest"] = "create_task_request";
    PermissionKey["RespondTaskRequest"] = "respond_task_request";
    // RanchBook
    PermissionKey["EditPlantings"] = "edit_plantings";
})(PermissionKey || (PermissionKey = {}));
